module.exports = __webpack_public_path__ + "static/media/economy_n.d35b833f.png";